import Vue from 'vue';

const remodalEventBus = new Vue();

export default remodalEventBus;
